import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";

/**
 * Download Pasco Stream Use Case
 * Downloads a PASCO file as a binary blob stream
 */
export class DownloadPascoStreamUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(pascoId: string): Promise<Blob> {
        if (!pascoId) {
            throw new Error("Pasco ID is required");
        }

        return await this.pascoRepository.downloadStream(pascoId);
    }
}
